'use strict';

import Masonry from 'masonry-layout';

export function init() {
    var elem = document.querySelector('.social-panel__list');

    if (!elem) {
        return false;
    }

    var msnry = new Masonry( elem, {
        itemSelector: '.social-panel__item',
        horizontalOrder: true,
        gutter: 30
    });

    return msnry;
}
